import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';
import { ADMISION } from './Styles/StylesAdmision';

import logo from "../../assets/img/logo_menu_black.png";

class EstadoDeCuentaRpt extends Component {
    state = {  }
    contenido = () => {
        let { datos } = this.props;
        const styles = StyleSheet.create(ADMISION[0]);
        let errores = 0;
        
        let cuentas = () => {
            if (datos[0].length === 0) return (
                <View style={[styles.row]}>
                    <Text style={[styles.colTabla10, styles.font9, styles.bordeCol11, {textAlign: "center"}]}>No existen aspirantes</Text>
                </View>
            )

            let estilos = (tipo) => {
                if (tipo === "Error")return ({ backgroundColor: "#d7d5d5" })
            }

            let detErr = (tipo) => {
                if (tipo === "Error") errores++;
            }

            let montoBs = (nombre) => {
                if (nombre === "" || nombre === null) return null;
                return `${nombre} Bs.`
            }

            return (
                datos[0].map(option => (
                    <View key={option.num} style={[styles.row]}>{detErr(option.resultado)}
                        <Text style={[styles.colTablaCuenta1, styles.font7, styles.bordeCol11, styles.borderTop, styles.center, estilos(option.resultado)]}>{option.num}</Text>
                        <Text style={[styles.colTablaCuenta2, styles.font8, styles.bordeCol9, styles.borderTop, styles.center, estilos(option.resultado)]}>{option.fecha}</Text>
                        <Text style={[styles.colTablaCuenta3, styles.font6, styles.bordeCol9, styles.borderTop, estilos(option.resultado)]}>{option.descripcion}</Text>
                        <Text style={[styles.colTablaCuenta4, styles.font8, styles.bordeCol9, styles.borderTop, styles.center, estilos(option.resultado)]}>{montoBs(option.debe)}</Text>
                        <Text style={[styles.colTablaCuenta4, styles.font8, styles.bordeCol9, styles.borderTop, styles.center, estilos(option.resultado)]}>{montoBs(option.haber)}</Text>
                        <Text style={[styles.colTablaCuenta4, styles.font8, styles.bordeCol9, styles.borderTop, styles.center, estilos(option.resultado)]}>{montoBs(option.saldo)}</Text>
                    </View>
                ))
            )
        }

        let messErr = () => {
            if (errores > 0) return `Este estado de cuenta presenta ${errores} error(es) en los asientos, en tal sentido este documento queda INVALIDADO para su uso. Dichos errores quedan resaltados en el listado`
        }

        return (
            <React.Fragment>
                <View style={styles.row}>
                    <Image
                        style={[styles.colContent40, styles.logo]}
                        src={logo}
                    />
                    <View style={[styles.colContent60, styles.header1Left,{marginTop: 14,}]}>
                        <Text style={[styles.Negrita]}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                        <Text style={[styles.textPeq]}>REGISTRO M.E, Nº 130 G.O. Nº 36.719  9 JUNIO 1.999 | RIF.J-30583313-3</Text>
                    </View>
                </View>
                <Text style={[styles.titulo, styles.header1Right, styles.custonMt10, styles.customMl,
                    {fontSize: 14, backgroundColor: "#777", color:"#FFF", padding: 2, borderRadius: 2}]}>
                    ESTADO DE CUENTA
                </Text>
                <View style={[styles.bordeConstancia, {backgroundColor: "#FFF", padding: 4,}]}>
                    <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>I. DATOS DEL ESTUDIANTE</Text>
                    <View style={[styles.row, {padding: 5, backgroundColor: "#fff"}]}>
                        <Text style={[styles.col2, styles.font9, {textAlign: "justify"}]}>
                            Cédula: {datos[1].Ci}
                        </Text>
                        <Text style={[styles.col4, styles.font9, {textAlign: "right"}]}>
                            Nombre y Apellido: {datos[1].Estudiante}
                        </Text>
                    </View>
                    <View style={[styles.row, {padding: 5, marginTop: -1, backgroundColor: "#fff"}]}>
                        <Text style={[styles.col3, styles.font9]}>
                            Carrera:  {datos[1].Carrera}
                        </Text>
                        <Text style={[styles.col3, styles.font9, {textAlign: "right", color: "#c60000"}]}>
                            Estatus:  {datos[1].Deuda}
                        </Text>
                    </View>
                </View>
                <View style={[styles.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF",}]}>
                    <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>II. DESCRIPCIÓN DE LOS ASIENTOS</Text>
                    <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff"}]}>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTablaCuenta1, styles.font9, styles.bordeCol11, styles.borderTop, {textAlign: "center", backgroundColor: "#777", color:"#FFF"}]}>N°</Text>
                            <Text style={[styles.colTablaCuenta2, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Fecha</Text>
                            <Text style={[styles.colTablaCuenta3, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Descripcion</Text>
                            <Text style={[styles.colTablaCuenta4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Facturado</Text>
                            <Text style={[styles.colTablaCuenta4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Pagado</Text>
                            <Text style={[styles.colTablaCuenta4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Balance</Text>
                        </View>
                        {cuentas()}
                        <View style={[styles.row]}>
                            <Text style={[styles.col6, styles.font9, {marginTop: 10, color: "#c60000"}]}>
                                {messErr()}
                            </Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.footer]}>
                    <View style={[styles.row]}>
                        <View style={[styles.col6]}>
                        <Text style={[styles.linea3]}></Text>
                            <Text style={[styles.encabezado2]}>
                                Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                C.P.1061  Edo Miranda - Caracas - Venezuela
                            </Text>
                            <Text style={[styles.encabezado2, {marginTop: -5}]}>
                                Telefax: +58 212 9930983 | 9939139 | 9910710.
                            </Text>
                        </View>
                    </View>
                </View>
            </React.Fragment>
        )
    }

    render() { 
        const styles = StyleSheet.create(ADMISION[0]);
        return (
            <PDFViewer style={styles.section}>
                <Document title="Estado de Cuenta del Estudiante">
                    <Page size="letter" style={styles.body}>
                        <View>
                            {this.contenido()}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}
 
export default EstadoDeCuentaRpt;


// WEBPACK FOOTER //
// ./src/components/Reportes/EstadoDeCuentaRpt.jsx